import { render, staticRenderFns } from "./custom-audiences-list.vue?vue&type=template&id=499c6791&"
import script from "./custom-audiences-list.vue?vue&type=script&lang=js&"
export * from "./custom-audiences-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports